import React, { Fragment, useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import useInterval from 'core/hooks/use-interval'
import { randomInt } from 'core/helpers/number-helpers'

import Window from 'core/components/Window'
import WPArticle from 'core/components/WPArticle'

import DynamiteAttachment from 'dynamite/components/DynamiteAttachment'
import DynamitePress from 'dynamite/components/DynamitePress'
import GlobalContext from 'core/contexts/global-context'

const DynamiteList = props => {
  const { screenWidth } = useContext(GlobalContext)
  const [queue, setQueue] = useState([])
  const [cap, setCap] = useState(0)
  const [int, setInt] = useState(200)
  const [closed, setClosed] = useState([])

  const maxWidth = screenWidth * 0.3

  const advance = () => {
    if (cap < queue.length) {
      setCap(cap + 1)
    } else {
      if (int) setInt(null)
    }
  }

  const close = e => {
    const field = parseInt(e.target.dataset.field, 10)

    if (closed.indexOf(field) !== -1) return

    setClosed([...closed, field])
  }

  useEffect(() => {
    setQueue(props.items)
    setCap(1)
  }, [])

  useInterval(advance, int)

  return (
    <Fragment>
      {queue.slice(0, cap).map((item, i) => {
        const x = randomInt(10, 60)
        const y = randomInt(10, 20)

        return (() => {
          switch (item.post_type) {
            case 'attachment':
              return (
                <Window
                  open={closed.indexOf(item.ID) === -1}
                  key={i}
                  width="auto"
                  height="auto"
                  mobile={false}
                  x={`${x}%`}
                  y={`${y}%`}
                  titlebar={{ title: item.filename, close: close, datafield: item.ID.toString() }}
                  bounds={null}
                  maxWidth={`${maxWidth}px`}
                >
                  <DynamiteAttachment item={item} sizeIndex={i % 2 === 0 ? 0 : 1} />
                </Window>
              )
            case 'press':
              return (
                <Window
                  open={closed.indexOf(item.ID) === -1}
                  key={i}
                  width="auto"
                  height="auto"
                  mobile={false}
                  x={`${x}%`}
                  y={`${y}%`}
                  titlebar={{
                    title: item.fields.outlet,
                    close: close,
                    datafield: item.ID.toString()
                  }}
                  bounds={null}
                  maxWidth={`${maxWidth}px`}
                >
                  <DynamitePress item={item} />
                </Window>
              )
            default:
              return (
                <Window
                  open={closed.indexOf(item.ID) === -1}
                  key={i}
                  width="auto"
                  height="auto"
                  mobile={false}
                  x={`${x}%`}
                  y={`${y}%`}
                  titlebar={{
                    title: `${item.post_name}.TXT`,
                    close: close,
                    datafield: item.ID.toString()
                  }}
                  bounds={null}
                  maxWidth={`${maxWidth}px`}
                >
                  <WPArticle content={item.post_content} style={{ maxWidth: '600px' }} />
                </Window>
              )
          }
        })()
      })}
    </Fragment>
  )
}

DynamiteList.defaultProps = {
  items: []
}

DynamiteList.propTypes = {
  items: PropTypes.array
}

export default DynamiteList
